import { useConnectWallet } from '@web3-onboard/react';
import { BankxButton } from 'components/BankxButton';
import { BankxDashboardLayout } from 'components/layouts/BankxDashboardLayout';
import ReferralFooter from 'components/ReferralFooter';
import { SwapBox } from 'components/SwapBox';
import { useGlobalValues } from 'context/ContractValuesProvider';
import { TokenLabels } from 'helpers/labels';
import useOnScreen from 'hooks/useOnScreen';
import useRecursiveTimeout from 'hooks/useRecursiveTimeout';
import { CurrentPrices } from 'pages/Silver';
import React, {
    useCallback, useRef, useState
} from 'react';

function XSDPage() {
    const {
        silverPrice,
        xsdPrice,
        priceDifference: priceDifferenceOutput,
    } = useGlobalValues();
    const [{ wallet }] = useConnectWallet();
    const userAddress = wallet?.accounts[0].address;

    // video autoplay
    const [playing, setPlaying] = useState(0);
    const ref = useRef<HTMLDivElement>(null);
    const isVisible = useOnScreen(ref);
    const playVideo = useCallback(() => {
        if (isVisible && !playing) {
            setPlaying(1);
        }
    }, [
        setPlaying,
        isVisible,
        playing
    ]);
    useRecursiveTimeout(playVideo, 100);

    return (
        <BankxDashboardLayout>
            <link rel='stylesheet' href='/css/landing.css' />
            <div className='landing_container'>
                <h1>
                    Have you lost money with stablecoins?
                    Or just don&apos;t know the right one to choose?
                </h1>

                <br /><br />

                <h3>Stablecoins on the market have lots of problems:</h3>
                <ul>
                    <li>
                        Terra Luna, with no collateral, lost $60B as it went to ZERO.
                    </li>
                    <li>
                        Silicon Valley Bank, holding collateral for USDC, went bankrupt.
                    </li>
                    <li>
                        USDC has been estimated to earn $1.6B a year using YOUR money.
                    </li>
                    <li>
                        Centralized stablecoins, like USDT, can be SHUT DOWN.
                    </li>
                    <li>
                        Other collateral-backed stablecoins like DAI can be LIQUIDATED.
                    </li>
                    <li>
                        USD stablecoins face tremendous LOSS in purchasing power from inflation.
                    </li>
                </ul>

                <br /><br />

                <div
                    style={{
                        maxWidth: 655,
                        width: '100%',
                    }}
                >
                    <h3 className='bankXis'>BankX is...</h3>
                </div>

                <ul>
                    <li>
                        Silver-Pegged to hedge against inflation.
                    </li>
                    <li>
                        Crypto-Backed so there is value you can redeem anytime.
                    </li>
                    <li>
                        A Blockchain-controlled collateral system only accessed by you.
                    </li>
                    <li>
                        Designed so the collateral backing it is never liquidated.
                    </li>
                    <li>
                        Fully decentralized so it cannot be shut down.
                    </li>
                    <li>
                        A stablecoin where YOU earn the interest for minting it.
                    </li>
                </ul>

                <br /><br />

                <h2>
                    Whenever the price of the XSD stablecoin is below the price of 1
                    gram of silver, you are buying it at a discount.
                </h2>
                <br />
                <div ref={ref} className="bankx-iframe-container">
                    <iframe
                        // width='1250'
                        // height='709'
                        src={`https://www.youtube.com/embed/LHl6I1zesyM?rel=0&amp;autoplay=${playing}&mute=1`}
                        title='YouTube video player'
                        frameBorder='0'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                        className='youtubeVideo'
                    />
                </div>
                <br /><br />

                <h1>It is easy to do <br className="cta-break-1110-min" />and takes 2 steps:</h1>
                <br />
                <ol>
                    <li>
                        Connect your METAMASK wallet on this web page.
                        <br /> Don’t have a METAMASK? Click here: <a href='https://metamask.io/'>metamask.io</a>
                    </li>
                    <li>
                        Use the SWAP box below to trade for the XSD stablecoin.
                    </li>
                </ol>
                <br /><br />

                <CurrentPrices
                    {...{
                        silverPrice,
                        xsdPrice,
                        priceDifferenceOutput,
                        userAddress
                    }}
                />

                <div
                    className='xsd-swap-container'
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '20px',
                    }}>
                    <SwapBox
                        disableDarkTheme={false}
                        forcedSourceToken={TokenLabels.Erc}
                        forcedTargetToken={TokenLabels.Xsd}
                        hasLandingPageRedirect
                        withLiquidityPoolInfo={false}
                        addBorder={true}
                    />
                    <h3 className="xsd-swap-cta">
                        That is it! You now own the best designed
                        and decentralized stablecoin on the market.
                    </h3>
                </div>
                <ReferralFooter userAddress={userAddress} route='xsd' />
                <div style={{
                    display: 'flex',
                    gap: '2rem',
                    marginTop: '5rem',
                }}>
                    <BankxButton onClick={() => window.open('https://docs.bankx.io/', '_blank', 'noopener noreferrer')}>
                        Still Have More Questions?
                    </BankxButton>
                    <BankxButton onClick={() => window.open('https://t.me/BankXio', '_blank', 'noopener noreferrer')}>
                        Join The Conversation
                    </BankxButton>
                </div>
            </div>
        </BankxDashboardLayout>
    );
}

export default XSDPage;
